export enum MilkingMethodEnum {
	a4 = 'A4',
	am4 = 'AM4',
}

export enum MilkingAlertsEnum {
	A = 'Id oficial no existe',
	B = 'Animal de baja',
	C = 'Animal en otra ganadería',
	D = 'No existe parto a esa fecha',
}

export enum MilkingIncidencesEnum {
	I01 = '01 - Control estimado en leche, grasa y proteína',
	I02 = '02 - Estimación de leche',
	I03 = '03 - Estimación de grasa',
	I04 = '04 - Estimación de proteína',
	I05 = '05 - Estimación de grasa y proteína',
	I06 = '06 - Estimación de extracto seco',
	I20 = '20 - Intervalo inferior a 28 (A4, AT4 o AC4) o 38 (A6, AT6 o AC6) días respecto al control anterior por reorganización de Control Lechero',
	I99 = '99 - Tiempo entre parto y control superior al recomendado',
}
